import { render, staticRenderFns } from "./ProgettiTicket.vue?vue&type=template&id=5abd127c&scoped=true&"
import script from "./ProgettiTicket.vue?vue&type=script&lang=js&"
export * from "./ProgettiTicket.vue?vue&type=script&lang=js&"
import style0 from "./ProgettiTicket.vue?vue&type=style&index=0&id=5abd127c&prod&scoped=true&lang=css&"
import style1 from "./ProgettiTicket.vue?vue&type=style&index=1&id=5abd127c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abd127c",
  null
  
)

export default component.exports